var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3067 2.76408C13.8688 2.69888 14.4342 2.66638 15 2.66675C21.2187 2.66675 26.2 6.53742 28.3334 12.0001C27.8169 13.3289 27.1192 14.5798 26.26 15.7174M7.69335 4.69208C4.97335 6.35208 2.86669 8.92408 1.66669 12.0001C3.80002 17.4628 8.78135 21.3334 15 21.3334C17.5762 21.347 20.1056 20.6454 22.3067 19.3068M12.1734 9.17342C11.8019 9.54488 11.5072 9.98588 11.3062 10.4712C11.1052 10.9566 11.0017 11.4768 11.0017 12.0021C11.0017 12.5274 11.1052 13.0476 11.3062 13.5329C11.5072 14.0183 11.8019 14.4593 12.1734 14.8308C12.5448 15.2022 12.9858 15.4969 13.4712 15.6979C13.9565 15.899 14.4767 16.0024 15.002 16.0024C15.5274 16.0024 16.0475 15.899 16.5329 15.6979C17.0182 15.4969 17.4592 15.2022 17.8307 14.8308",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 1.33337L25.6667 22.6667",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hidePassword.519287189bd31e31121479b527c0b158.svg";
export { ForwardRef as ReactComponent };